import React, { useEffect } from 'react';

export default InteractiveLayer;

const style = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  colorScheme: 'normal', // rewrite cms' style. Cms set color-scheme: dark and iframe's background becomes white
  /*
   should be over player skin
  */
  zIndex: 'var(--interactive-layer-zindex, initial)',
  pointerEvents: 'var(--interactive-layer-events, "none")',
};

/**
 * @name InteractiveLayer
 * @return {Element}
 */
function InteractiveLayer(props) {
  useEffect(() => {
    props.registerEvent('interactive:seek');
    return () => {
      props.unRegisterEvent('interactive:seek');
    };
  }, []);

  return <div id={'mggp-interactive-container'} style={style} />;
  /*
    if (enable || true) {
      return (
        <iframe
          src={`${url}?param1=foo&param2=boo`}
          id={containerId}
          style={style}
        />
      )
    }

    return null;
  */
}
